export default __webpack_public_path__ + "static/media/kalingo-left-arrow.8de63f12.svg";